module.exports = __webpack_public_path__ + "img/definitive.84056eec.png";